// apps/web/src/components/PublicRoute.tsx

import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';

/**
 * PublicRoute - Prevents authenticated users from accessing login/register pages
 * Redirects them to appropriate dashboard or pending verification
 */
const PublicRoute: React.FC = () => {
  const { user, token } = useAuthStore();

  // If user is logged in
  if (user && token) {
    // If not verified, send to pending page
    if (user.verificationStatus === 'PENDING') {
      return <Navigate to="/onboarding/pending" replace />;
    }

    // If verified, send to dashboard
    return <Navigate to="/dashboard" replace />;
  }

  // User is not logged in, allow access to public routes (login/register)
  return <Outlet />;
};

export default PublicRoute;